import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

const SearchResultsPageEager = lazy(
  () =>
    import('./SearchResultsPage.eager').then(mod => ({
      default: mod.SearchResultsPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

const SearchPageResolver = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/Search/SearchPageResolver'
    ).then(mod => ({
      default: mod.SearchPageResolver,
    })),
  {isSsrAndNeedsHydration: true},
);

export const SearchResultsPage = () => (
  <SearchPageResolver SearchPage={<SearchResultsPageEager />} />
);
